import React from 'react';
import { styled } from 'styled-components';
import { gridChannelHeight, gridGap } from '../tv-guide-types';
import { jsx as _jsx } from "react/jsx-runtime";
export const GridPositionLine = ({
  pixelsPerMinute,
  programs = [],
  now
}) => {
  const contentHeight = programs.length * (gridChannelHeight + gridGap) - gridGap;
  return /*#__PURE__*/_jsx(Layout, {
    pixelsPerMinute: pixelsPerMinute,
    children: programs && now && /*#__PURE__*/_jsx(NowLine, {
      style: {
        left: `${now}px`,
        height: `${contentHeight}px`
      }
    })
  });
};
const Layout = styled.div.withConfig({
  displayName: "GridPositionLine__Layout",
  componentId: "sc-1rt0o6k-0"
})(["display:flex;position:relative;"]);
const NowLine = styled.div.withConfig({
  displayName: "GridPositionLine__NowLine",
  componentId: "sc-1rt0o6k-1"
})(["position:absolute;width:1px;z-index:80;background-color:white;pointer-events:none;"]);